export const CLEAR_DEPRECIATION_RULES = 'CLEAR_DEPRECIATION_RULES';
export const GET_DEPRECIATION_RULES = 'GET_DEPRECIATION_RULES';
export const GET_DEPRECIATION_RULE = 'GET_DEPRECIATION_RULE';
export const CLEAR_DEPRECIATION_RULE = 'CLEAR_DEPRECIATION_RULE';
export const FLAG_DEPRECIATION_RULE_ACTIVITY =
  'FLAG_DEPRECIATION_RULE_ACTIVITY';
